<template>
    <span v-if="renderSocialLinks">
        <li
            class="footer-header"
            v-html="labelText"
        />
        <li class="footer-social-icons">
            <a
                v-if="showFacebookLink"
                :href="facebookLink.Url"
                target="_blank"
                :title="facebookLink.Text" 
            >
                <span class="icon icon-facebook" />
            </a>
            <a
                v-if="showLinkedInLink"
                :href="linkedInLink.Url"
                target="_blank"
                :title="linkedInLink.Text"
            >
                <span class="icon icon-linkedin" />
            </a>
        </li>
    </span>
</template>

<script>
export default {
    name: 'FooterContactInformationSocialLinks',
    props: {
        labelText: {
            type: String,
            default() {
                return '';
            }
        },
        facebookLink: {
            type: Object,
            default() {
                return {};
            }
        },
        linkedInLink: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        showFacebookLink() {
            if (this.facebookLink === null) {
                return false;
            }

            return this.facebookLink.Url !== undefined;
        },
        showLinkedInLink() {
            if (this.linkedInLink === null) {
                return false;
            }

            return this.linkedInLink.Url !== undefined;
        },
        renderSocialLinks() {
            return this.showFacebookLink || this.showLinkedInLink;
        }
    }
};
</script>
